export const onDownloadByFileUrl = async ({
  filename,
  fileUrl,
  isPdf = false,
}: {
  filename: string;
  fileUrl?: string;
  isPdf?: boolean;
}): Promise<void> => {
  if (!fileUrl) return;

  const response = await fetch(fileUrl, {
    method: "GET",
    headers: {
      "Content-Type": isPdf ? "application/pdf" : "image/*",
    },
  }).catch((error) => {
    throw new Error(JSON.stringify(error));
  });

  if (response.status != 200) {
    console.error("Error fetching data:", {
      status: response.status,
      statusText: response.statusText,
    });
    return;
  }

  const blobData = await response.blob();
  const downloadUrl = URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link?.parentNode?.removeChild(link);
};

/**
 * https://バケットのurl/folder/folder/ファイル名_1111000011111.png?X_GOOGLE....のような形式のurlからファイル名+拡張子のみを抽出する
 * @param url string
 * @returns ファイル名+拡張子
 */
export const getFileNameAndExtension = (url: string) => {
  const encodedUrl = decodeURIComponent(url);
  const findQuestionSlice = encodedUrl.slice(0, encodedUrl.indexOf("?"));
  const findLastSlashSlice = findQuestionSlice.slice(findQuestionSlice.lastIndexOf("/") + 1);
  const findLastUnderScoreIndex = findLastSlashSlice.lastIndexOf("_");
  const findLastDotIndex = findLastSlashSlice.lastIndexOf(".");
  return findLastSlashSlice.slice(0, findLastUnderScoreIndex) + findLastSlashSlice.slice(findLastDotIndex);
};
